__turbopack_context__.v({
  "snowfall": "Snowfall-module-scss-module__ygEzYG__snowfall",
});
